import {h, render} from 'preact';
import {useEffect, useState} from 'preact/hooks';
import {useStateWithCallback} from '../../../Preact/Helpers/useStateWithCallback'
import Button from "./components/Button";

(() => {
    function ViewedCheckButton({nodeRef, csrfToken}) {
        const [error, setError] = useState(false);
        const [isFetching, setIsFetching] = useState(false);
        const [isViewed, setViewedState] = useStateWithCallback(false);
        const [isUser, setIsUser] = useState(false);

        const updateStatus = async (ev, viewed) => {
            setIsFetching(true);
            fetch(`/api/review`, {
                cache: "no-cache",
                method: "POST",
                body: JSON.stringify({node: nodeRef, state: viewed}),
                credentials: 'same-origin',
                headers: {
                    'X-Flow-Csrftoken': csrfToken,
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Erreur serveur!');
            }).then((data) => {
                setTimeout(() => setIsFetching(false), 1000);
                setViewedState(data.reviewed);
                setIsUser(data.loggedIn);
            }).catch((error) => {
                setIsFetching(false);
                console.error(error);
            });
        }

        const toggleViewed = (ev) => {
            setViewedState(!isViewed, (prevValue, newValue) => {
                updateStatus(ev, newValue);
            });
        };

        // firstload
        useEffect(() => {
            updateStatus(null, null);
        }, []);

        return (
            <Button showInfo={isUser} checked={isViewed} fetching={isFetching} onChange={toggleViewed}/>
        );
    }

    window.addEventListener('DOMContentLoaded', () => {
        const viewedCheckButton = document.querySelector('#ViewedCheckButton');
        if (!viewedCheckButton) return;
        const {node, token} = viewedCheckButton.dataset;
        if (node === '' || token === '') return;

        render(<ViewedCheckButton nodeRef={node} csrfToken={token}/>, viewedCheckButton);
    });
})();
